import { useEffect, type RefObject } from 'react';

/**
 * Puts the cursor in a field once its pop-over is visible. An anchored panel's first frame is hidden while it
 * measures itself (`useAnchoredPanel`), and a hidden field can't take focus, so `autoFocus` alone lands nowhere;
 * one frame later the panel is placed and shown.
 */
export function useFocusOnOpen(ref: RefObject<HTMLElement | null>, isEnabled = true): void {
  useEffect(() => {
    if (!isEnabled) return undefined;
    const frame = requestAnimationFrame(() => ref.current?.focus());
    return () => cancelAnimationFrame(frame);
  }, [ref, isEnabled]);
}
